module.exports = __webpack_public_path__ + "b34c29372ba97d72609d6e5d427f4bf2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/lambda-config.png
// module id = 265
// module chunks = 1